var style = {"pp-GridContainer":"pp-GridContainer","pp-GridItem":"pp-GridItem"};

export { style as default };
//# sourceMappingURL=GridContainer.module.scss.js.map
